module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"text":"Du har en ny repetisjon i"},"en":{"text":"You have a new repetition in"}}')
  delete Component.options._Ctor
}
